import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { LOOKUP_CONTACT_ROLE } from "./contactsConfig";

export function useContactLookups() {
  const { getAccessTokenSilently } = useAuth0();

  const listContactRoleQuery = useQuery(["contact-addresses"], async () => {
    const token = await getAccessTokenSilently();
    const res = await axios.get(LOOKUP_CONTACT_ROLE, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  return {
    contactRoles: listContactRoleQuery.data || [],
  };
}
